module.exports = __webpack_public_path__ + "img/rise.f672a1e6.svg";